import QUANTSE_EXT_1 from "./QUANTSE_EXT_1";
export default {
  QUANTSE_EXT_1,
};
